import reducers from './reducers'

// 文件入口切换时需修改或删除
export default [
  {
    id: '@ci/switchrecipient',
    reducerMap: reducers,
  },
]
